import { render, staticRenderFns } from "./ShopifyOrder.vue?vue&type=template&id=c9cc2d12&scoped=true"
import script from "./ShopifyOrder.vue?vue&type=script&lang=js"
export * from "./ShopifyOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cc2d12",
  null
  
)

export default component.exports